var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.09004 9.58511C9.03754 9.57761 8.97004 9.57761 8.91004 9.58511C7.59004 9.54011 6.54004 8.46011 6.54004 7.13261C6.54004 5.77511 7.63504 4.67261 9.00004 4.67261C10.3575 4.67261 11.46 5.77511 11.46 7.13261C11.4525 8.46011 10.41 9.54011 9.09004 9.58511Z",
    stroke: "#333333",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0551 14.5349C12.7201 15.7574 10.9501 16.4999 9.00007 16.4999C7.05007 16.4999 5.28007 15.7574 3.94507 14.5349C4.02007 13.8299 4.47007 13.1399 5.27257 12.5999C7.32757 11.2349 10.6876 11.2349 12.7276 12.5999C13.5301 13.1399 13.9801 13.8299 14.0551 14.5349Z",
    stroke: "#333333",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9 16.5C13.1421 16.5 16.5 13.1421 16.5 9C16.5 4.85786 13.1421 1.5 9 1.5C4.85786 1.5 1.5 4.85786 1.5 9C1.5 13.1421 4.85786 16.5 9 16.5Z",
    stroke: "#333333",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.8ac11c9ae91f014852ef3f50e9500a92.svg";
export { ForwardRef as ReactComponent };